import BridgeTransactionView from './BridgeTransactionView';

export default BridgeTransactionView;
